
import AbpBase from '@/lib/abpbase'
import { Component, Prop } from 'vue-property-decorator'
import CardBody from '@/components/card-body/index.vue'
import User from '@/entities/user'
import UserControl from '@/entities/user-control'
import SelectExtend from '@/mixins/select-extend'
import WorkZone from '@/entities/workzone'

@Component({
  components: { CardBody },
  mixins: [SelectExtend]
})
export default class UserEdit extends AbpBase {
  name: string = 'UserEdit'

  user: User = new User()

  selectWorkingZone: Array<any> = []

  editPassword: boolean = false

  appRoleList = [
    {
      label: 'None',
      value: 'None'
    },
    {
      label: 'Admin',
      value: 'Admin'
    },
    {
      label: 'Store',
      value: 'Store'
    },
    {
      label: 'Warehouse',
      value: 'Warehouse'
    },
    {
      label: 'Driver',
      value: 'Driver'
    },
    {
      label: 'Driver PKT',
      value: 'Driver PKT'
    },
    // 2026-09-04 - Added by AI (CR_PILOT_STORE) - 門店試點角色（APK 選單用；Web 權限請另指派 Store_Pilot20 Web Role）
    {
      label: 'Pilot Store',
      value: 'Pilot Store'
    }
  ]

  validatePass = (rule, value, callback) => {
    console.log(value);
    console.log(this.user);
    if (!value) {
      callback(new Error('Please input Confirm Password'))
    } else if (value !== this.user.password) {
      callback(new Error('Two input Password must be consistent'))
    } else {
      callback()
    }
  }

  validateEmail = (rule, value, callback) => {
    const mailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!value) {
      return callback(new Error('Please input Email Address'))
    }
    setTimeout(() => {
      if (mailReg.test(value)) {
        callback()
      } else {
        callback(new Error('Invalid Email Address'))
      }
    }, 100)
  }

  rules = {
    userName: [
      {
        required: true,
        message: 'Please input User Name',
        trigger: 'blur'
      }
    ],
    name: [
      {
        required: true,
        message: 'Please input Name',
        trigger: 'blur'
      }
    ],
    roles: [
      {
        required: false,
        message: 'Please select Roles',
        trigger: 'change'
      }
    ],
    appRole: [
      {
        required: true,
        message: 'Please select App Role',
        trigger: 'change'
      }
    ],
    password: [
      {
        required: true,
        message: 'Please input Password',
        trigger: 'blur'
      }
    ],
    confirmPassword: [
      {
        required: true,
        validator: this.validatePass,
        trigger: 'blur'
      }
    ],
    emailAddress: [
      {
        required: true,
        validator: this.validateEmail,
        trigger: 'blur'
      }
    ],
    isActive: [
      {
        required: true,
        message: 'Please Select Status',
        trigger: 'change'
      }
    ]
  }

  workingZoneRules = {
    workingZone: [
      {
        required: true,
        message: 'Please input Working Zone',
        trigger: 'blur'
      }
    ],
    name: [
      {
        required: true,
        message: 'Please input Name',
        trigger: 'blur'
      }
    ],
    locCode: [
      {
        required: true,
        message: 'Please input Loc Code',
        trigger: 'blur'
      }
    ]
  }

  loading = false

  doCancel() {
    this.$refs.form && (this.$refs.form as any).resetFields()
    this.$router.back()
  }

  get roleList() {
    return (this.$store.state.role.list || []).map(t => {
      return {
        roleId: t.id,
        roleName: t.name,
        roleDisplayName: t.displayName
      }
    })
  }

  workingZoneList: Array<any> = []

  get workZoneOptions() {
    return this.$store.state.workzone.options
  }

  // 2026-08-22 - Added by AI (CR-25-09) - multiple working zone support
  /**
   * MultipleStore 設定內的 role DisplayName（已小寫正規化）
   */
  get configRoleNames(): Array<string> {
    return this.$store.state.userworkingzone.configRoleNames || []
  }

  /**
   * 依「當前勾選的 Web Role」即時判斷是否多選。
   * 刻意不用後端回傳的 allowMultipleWorkingZone —— 那個是存檔時的狀態，
   * 新增使用者時不存在，且 admin 勾／取消 role 時不會即時更新。
   */
  get allowMultipleWorkingZone(): boolean {
    const configured = this.configRoleNames.map(t =>
      (t || '').trim().toLowerCase()
    )
    if (!configured.length) {
      return false
    }
    const selectedRoleIds = this.user.roles || []
    return this.roleList
      .filter(r => selectedRoleIds.indexOf(r.roleId) >= 0)
      .some(
        r =>
          configured.indexOf((r.roleDisplayName || '').trim().toLowerCase()) >= 0
      )
  }

  /**
   * 單／多選共用的 v-model 中介層。
   *
   * ⚠️ 必須用 computed getter/setter 隔離：el-select 切換 :multiple 時
   * v-model 的型別會在 number 與 Array<number> 之間變動，
   * 直接綁 user.workingZone 會讓 element-ui 殘留舊值或拋錯。
   *
   * setter 同時維護兩個欄位：
   *   workingZone  = 主要 zone（單一值，BR5：Mobile API 與 35 個畫面依賴它）
   *   workingZones = 完整清單（送後端寫入 epod_user_workingzone）
   */
  get workingZoneModel(): any {
    return this.allowMultipleWorkingZone
      ? this.user.workingZones || []
      : this.user.workingZone
  }

  set workingZoneModel(val: any) {
    if (this.allowMultipleWorkingZone) {
      const list = val || []
      this.$set(this.user, 'workingZones', list)
      this.$set(this.user, 'workingZone', list.length ? list[0] : null)
    } else {
      this.$set(this.user, 'workingZone', val)
      this.$set(this.user, 'workingZones', val ? [val] : [])
    }
  }

  async getConfigRoleNames() {
    await this.$store.dispatch({
      type: 'userworkingzone/getConfigRoleNames'
    })
  }

  async getWorkingZoneList() {
    let res = await this.$store.dispatch({
      type: 'user/getAllLimit'
    })
    this.workingZoneList = res.map(t => {
      return {
        label: `${t.workingZone}-${t.name}`,
        value: t.id
      }
    })
  }

  async getRoleAllList() {
    await this.$store.dispatch({
      type: 'role/getAll'
    })
  }

  async doCreateOrUpdate() {
    ;(this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      let roles = []
      this.roleList.map(t => {
        this.user.roles.map(n => {
          if (t.roleId === n) {
            roles.push(t)
          }
        })
      })
      let data = {
        user: {
          ...this.user,
          userControl: {
            ...this.user.userControl,
            workingZone: this.user.workingZone,
            // 2026-08-22 - Added by AI (CR-25-09) - multiple working zone
            // 單選使用者一律傳 null（= 本次不變更），不可傳 [] —— 空陣列在後端
            // 代表「明確清空」，會刪掉該使用者既有的 zone 指派
            workingZones: this.allowMultipleWorkingZone
              ? this.user.workingZones || []
              : null,
            appRole: this.user.appRole,
            vendor: this.user.vendor
          },
          roles: null
        },
        roles,
        assignedRoleNames: roles.map(t => {
          return t.roleName
        }),
        organizationUnits: []
      }
      // 2026-08-23 - Modified by AI - Save 失敗時必須給回饋，不可靜默
      try {
        await this.$store.dispatch({
          type: 'user/createOrUpdateUser',
          data
        })
      } catch (e) {
        console.log(e)
        this.notifySaveError(e)
        return
      }
      this.$notify.success({
        title: 'Success',
        message: 'Save Success'
      })
      this.doCancel()
    })
  }

  // 2026-08-23 - Added by AI - Save 靜默失敗的補救
  /**
   * 為什麼需要這個方法：
   *
   * antiforgery / session 失效時（例如同一個瀏覽器切換過登入帳號，XSRF-TOKEN
   * cookie 仍綁在前一個使用者的 claims 上），後端 ABP 的
   * AbpAutoValidateAntiforgeryTokenAuthorizationFilter 會在進入 AppService
   * 之前就擋掉請求，回 **400 且 response body 為空**。
   *
   * 此時 `api/ajax.ts` 的這段分支會直接 reject 而不顯示任何訊息：
   *     if (status === 400 && typeof data === 'string') { return Promise.reject(error) }
   * （該分支原意是處理 webpack proxy 在後端未啟動時回傳的 HTML body，
   *   但空字串同樣是 string，因此把這種 400 一起吃掉了。）
   *
   * 結果：按下 Save 完全沒有反應，看起來像按鈕壞掉 —— 使用者實際回報的症狀。
   * 這裡只在本畫面補上回饋，不改動全域 axios 攔截器（影響全站所有 API）。
   */
  private notifySaveError(e: any) {
    const res = e && e.response
    const body = res && res.data
    const abpMessage =
      body && typeof body === 'object' && body.error && body.error.message

    // 攔截器已針對帶有 ABP error body 的回應彈過訊息，這裡不重複顯示
    if (abpMessage) {
      return
    }

    if (res && res.status === 400) {
      this.$notify.error({
        title: 'Save Failed',
        message:
          'Your security token is no longer valid — this happens after switching accounts in the same browser. Please refresh the page or sign in again, then retry.',
        duration: 0
      })
      return
    }

    this.$notify.error({
      title: 'Save Failed',
      message:
        'Save failed. Please try again, and contact your administrator if it keeps happening.'
    })
  }

  workingZoneFrom: WorkZone = new WorkZone()

  showWorkingZoneDialog = false
  addWorkingZoneLoading = false

  addWorkingZoneClick() {
    this.showWorkingZoneDialog = true
  }

  cancelWorkingZone() {
    this.$refs.workingZoneRef &&
      (this.$refs.workingZoneRef as any).resetFields()
    this.showWorkingZoneDialog = false
  }

  async doSubmitWorkingZone() {
    ;(this.$refs.workingZoneRef as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
      try {
        this.addWorkingZoneLoading = true
        this.workingZoneFrom.type = 'Store'
        let newWorkingZone = await this.$store.dispatch({
          type: 'workzone/createOrUpdate',
          data: {
            workingZone: this.workingZoneFrom
          }
        })
        this.workingZoneList.push({
          label: `${newWorkingZone.workingZone}-${newWorkingZone.name}`,
          value: newWorkingZone.id
        })
        this.user.workingZone = newWorkingZone.id
        this.cancelWorkingZone()
        this.$notify.success({
          title: 'Success',
          message: 'Save Success'
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.addWorkingZoneLoading = false
      }
    })
  }

  async created() {
    try {
      this.loading = true
      let id = +this.$route.params.id
      // 2026-08-22 - Modified by AI (CR-25-09) - also load MultipleStore config role names
      await Promise.all([
        this.getWorkingZoneList(),
        this.getRoleAllList(),
        this.getConfigRoleNames()
      ])
      this.rules.roles.map(t => {
        this.$set(t, 'required', true)
      })
      if (!id || id < 0) {
        this.$set(this.user, 'isActive', true)
        this.$set(this.user, 'appRole', 'None')
        // 2026-08-23 - Added by AI (CR-25-09) - roles 必須先 $set 才有響應性
        //
        // User 這個 class（entities/user.ts）只有 TypeScript 型別宣告，沒有任何欄位
        // 初始值，因此 `new User()` 在執行期是一個「完全沒有自有屬性」的物件。
        // Vue 2 只能觀察建立實例時已存在的屬性，所以：
        //   - isActive / appRole 有 $set → 響應式 → 畫面會跟著更新（原本就正常）
        //   - roles 沒有 $set → Web Role 的 v-model 是「新增一個屬性」→ 非響應式
        //
        // 後果：admin 勾選 Assistant Manager 後，computed allowMultipleWorkingZone
        // 依賴 this.user.roles，但該屬性的變更不會觸發重算，於是永遠是 false，
        // Working Zone 一直停在單選，不會切成多選。
        //
        // 編輯既有使用者時沒這問題，因為下方會 $set(this.user, 'roles', ...)。
        // 這裡補上新增使用者的情況，讓兩條路徑一致。
        this.$set(this.user, 'roles', [])
        this.rules.appRole.map(t => {
          this.$set(t, 'required', true)
        })
        return
      }

      this.$set(this.user, 'id', id)
      
      let res = await this.$store.dispatch({
        type: 'user/get',
        id
      })
      
      //original code
      //this.user = res.user

      //new code
      this.$set(this.user, 'creationTime', res.user.creationTime);
      this.$set(this.user, 'emailAddress', res.user.emailAddress);
      this.$set(this.user, 'isAppUser', res.user.isAppUser);
      this.$set(this.user, 'name', res.user.name);
      this.$set(this.user, 'roles', res.user.roles);
      this.$set(this.user, 'surname', res.user.surname);
      this.$set(this.user, 'userControl', res.user.userControl);
      this.$set(this.user, 'userId', res.user.userId);
      this.$set(this.user, 'userName', res.user.userName);
      this.$set(this.user, 'workingZoneName', res.user.workingZoneName);
      this.$set(this.user, 'isActive', res.user.isActive);

      let resUserControl = res.user.userControl || {}
      // flat
      Object.keys(resUserControl).map(k => {
        if ((k + '').toUpperCase() !== 'ID' && resUserControl[k]) {
          this.$set(this.user, k, resUserControl[k])
        }
      })
      this.$set(
        this.user,
        'roles',
        res.roles.filter(t => t.isAssigned).map(t => t.roleId) || []
      )
      this.rules.appRole.map(t => {
        this.$set(t, 'required', true)
      })
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }
}
